import { render, staticRenderFns } from "./WarehousesTable.vue?vue&type=template&id=2f6783d0"
import script from "./WarehousesTable.vue?vue&type=script&lang=js"
export * from "./WarehousesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports